import { render, staticRenderFns } from "./UserProfileEdit.vue?vue&type=template&id=cd575eb4&scoped=true"
import script from "./UserProfileEdit.vue?vue&type=script&setup=true&lang=ts"
export * from "./UserProfileEdit.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./UserProfileEdit.vue?vue&type=style&index=0&id=cd575eb4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd575eb4",
  null
  
)

export default component.exports